import { getObjectsState, getWarehouses, selectWarehouseStatus } from 'containers/Warehouses/warehousesSlice'
import { selectUserId } from 'containers/Login/loginSlice'
import { useReduxSelector, useReduxDispatch } from 'store'
import { useState, useEffect } from 'react'

const useWarehousesLoading = (reload = true, alwaysReloadWarehouseData = false) => {
  const status = useReduxSelector(selectWarehouseStatus)
  const [isLoading, setLoading] = useState(status !== 'succeed')
  const clientId = useReduxSelector(selectUserId)
  const dispatch = useReduxDispatch()

  useEffect(() => {
    if (clientId && (reload || alwaysReloadWarehouseData)) {
      dispatch(getWarehouses(clientId)).then(() => {
        setLoading(false)
      })
      if (reload) {
        dispatch(getObjectsState())
      }
    }
  }, [clientId, dispatch, reload, alwaysReloadWarehouseData])

  return isLoading
}

export default useWarehousesLoading